import { defaultListPayload } from 'coreOld/constants';
import { removeNullValuesNestedObject } from 'coreOld/utils';

export const getListPayload = (filters = {}, params = {}) => {
  const payload = {
    ...defaultListPayload,
    ...params,
  };

  return removeNullValuesNestedObject({
    ...payload,
    filters,
  });
};
